var vCard = require('vcard-parser');

document.addEventListener("DOMContentLoaded", function(event) {
  const textWrappers   = document.querySelectorAll('.acceptance .wpcf7-list-item .wpcf7-list-item-label');
  const qrOpen         = document.querySelector('#open-scanner');
  const qrClose        = document.querySelector('#close-scanner');
  const scannerModal   = document.querySelector('.lp-form__scanner-modal');

  let html5QrcodeScanner = null;
  
  function truncate(str, no_words) {
    return str.split(" ").splice(0,no_words).join(" ");
  }

  textWrappers.forEach((item) => {
    const fullText      = item.innerHTML;
    const shortText     = truncate( item.innerHTML, 20);
    const parentWrapper = item.closest('.wpcf7-list-item');
    const label         = parentWrapper.querySelector('label');

    const showMore = `<span class="lp-form__show-more"></span>`
    const showLess = `<span class="lp-form__show-less"></span>`

    item.innerHTML = shortText;
    
    label.innerHTML += showMore;
    label.innerHTML += showLess;

    parentWrapper.classList.add('short');

    const moreButton = parentWrapper.querySelector('.lp-form__show-more');
    const lessButton = parentWrapper.querySelector('.lp-form__show-less');

    parentWrapper.style.opacity = 1;

    moreButton.addEventListener('click', function(element) {
      const parent = element.target.closest('.wpcf7-list-item');
      const item   = parent.querySelector('.wpcf7-list-item-label');
      parentWrapper.classList.remove('short');
      parentWrapper.classList.add('long');
      item.innerHTML= fullText;
    });

    lessButton.addEventListener('click', function(element) {
      const parent = element.target.closest('.wpcf7-list-item');
      const item   = parent.querySelector('.wpcf7-list-item-label');
      parentWrapper.classList.add('short');
      parentWrapper.classList.remove('long');
      item.innerHTML = shortText;
    });
  });

  document.addEventListener( 'wpcf7mailsent', function( event ) {
    const thanks = document.querySelector('.lp-form__thank-you');
    const title = document.querySelector('.lp-form__sub-title');
    const text = document.querySelector('.lp-form__text');
    thanks.style.display = 'block';
    title.style.display = 'none';
    text.style.display = 'none';
    document.querySelectorAll("form.wpcf7-form > :not(.wpcf7-response-output)").forEach(el => {
      el.style.display = 'none';
    });
  }, false );

  const multiSelectWithoutCtrl = ( elemSelector ) => {
    let options = [].slice.call(document.querySelectorAll(`${elemSelector} option`));
    options.forEach(function (element) {
        element.addEventListener("mousedown", 
            function (e) {
                e.preventDefault();
                element.parentElement.focus();
                this.selected = !this.selected;
                return false;
            }, false );
    });
  }

  multiSelectWithoutCtrl('.multi-select');

  function fillFormWithVCardData(vCardData) {
    

    document.querySelector('input[name="fullname"]').value = vCardData.name || '';
    document.querySelector('input[name="gr4wp_company"]').value = vCardData.company || '';
    document.querySelector('input[name="email"]').value = vCardData.email || '';
    document.querySelector('input[name="gr4wp_phone"]').value = vCardData.phone || '';
    document.querySelector('input[name="gr4wp_country"]').value = vCardData.country || '';
    document.querySelector('input[name="gr4wp_position"]').value = vCardData.position || '';

    console.log('fill:', vCardData);
  }

  function onScanSuccess(decodedText, decodedResult) {

    var card = vCard.parse(decodedText);
    console.log(card);


    const vCardData = {
      name: (card.n.[0].value.[0] ? card.n[0].value[0] : '') + (card.n.[0].value.[1] ? ' ' + card.n[0].value[1] : ''),
      company: card.org.[0].value ? card.org[0].value : '',
      email: card.email.[0].value ? card.email[0].value : '',
      phone: card.tel.[0].value ? card.tel[0].value :'',
      country: card.adr.[0].value.[6] ? card.adr[0].value[6] : '',
      position: card.title.[0].value ? card.title[0].value : ''
    };

    fillFormWithVCardData(vCardData);

    scannerModal.style.display = 'none';
    html5QrcodeScanner.clear();
  }


  qrOpen.addEventListener('click', function() {
    scannerModal.style.display = 'block';
    html5QrcodeScanner = new Html5QrcodeScanner(
      "reader", { fps: 10, qrbox: 250 });
    html5QrcodeScanner.render(onScanSuccess);
  });

  qrClose.addEventListener('click', function() {
    scannerModal.style.display = 'none';
    html5QrcodeScanner.clear();
  });
});
